import { Button, ClickAwayListener, IconButton } from "@mui/material";
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import Editor from "../../../../Editor/Editor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { createRoot, Root } from "react-dom/client";
import { tokenProcessingTest } from "../../../../TokenProcessing/TokenProcessing";
import DialogSetObjText from "../../../Module/Dialogs/DialogSetObjText";
import DialogCreateObj from "../../../Module/Dialogs/DialogCreateObj";
import {
  fontFlagsToCss,
  formEdit,
  getDefaultMenu,
  getEditorListFormat,
  getStyleWindow,
  setColor,
} from "../../../Tools/Tools";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import CircleIcon from "@mui/icons-material/Circle";
import CheckBoxMultiCheck from "../CheckBoxMultiCheck";
import LoadingMask from "../../../NotWorkArea(Side&Head)/LoadingMask";
import HistoryIcon from "@mui/icons-material/History";
import TextAreaWithButtons from "../../../Module/Dialogs/Components/TextAreaWithButtons";
import ContextMenu from "../../../NotWorkArea(Side&Head)/ContextMenu";
import DialogHistory from "../../../Module/Dialogs/DialogHistory";
import ConditionButton from "./ParamsComponents/ConditionButton";
import DialogSaveSample from "../../../Module/Dialogs/DialogSaveSample";
import { HandleSamples } from "../../../Tools/Requests";
import styles from "./ParamsStyles.module.css";
import clsx from "clsx";
import { EditStyle, ParamSetOption, Prefixes } from "../../../Tools/ProjectX";
import smetaAxios from "../../../../SmetaAxios";
import { smetaModals, SmetaModalsIdContext } from "../../../Tools/modalManager";

// функции для сплиттера с возможностью изменения размеров полей
let resize: {
  resizeMode?: boolean;
  target?: HTMLTableCellElement;
  cells?: NodeListOf<HTMLTableCellElement>;
  cell?: HTMLTableCellElement;
  size?: number;
  ctrlKey?: boolean;
} = {};

// функция включения live изменения размеров
function onMouseDown(ev: React.MouseEvent<HTMLTableCellElement>) {
  const record = ev.currentTarget.closest<HTMLTableRowElement>("TR")!;
  const table = record.parentElement as HTMLTableSectionElement;
  const el = record.querySelector<HTMLTableCellElement>(".td-name")!;
  const elements = table.querySelectorAll<HTMLTableCellElement>(".td-name")!;
  resize.resizeMode = true;
  resize.target = ev.currentTarget;
  resize.cells = elements;
  resize.cell = el;
}
// функция установки размеров после изменения
function onMouseUp(_ev: React.MouseEvent<HTMLDivElement>, width: React.RefObject<number>) {
  if (resize.size !== undefined) {
    if (resize.ctrlKey) {
      resize = {};
      return;
    }
    width.current = resize.size;
  }
  resize = {};
}

// функция live изменения размеров
function onMouseMove(ev: React.MouseEvent<HTMLDivElement>) {
  if (resize.resizeMode && resize.target && resize.cell && resize.cells) {
    const x = ev.clientX;
    const targetWidth = resize.target.clientWidth;
    const targetX = resize.target.getBoundingClientRect().x;

    if (ev.ctrlKey) {
      resize.ctrlKey = true;
      let size = x - targetWidth - targetX;
      size =
        (resize.cell.clientWidth / resize.cell.parentElement.clientWidth) * 100 +
        (size / resize.cell.parentElement.clientWidth) * 100;
      if (size < 30) size = 30;
      if (size > 70) size = 70;
      resize.cell.style.width = `${size}%`;
      return;
    }
    resize.cells.forEach((el) => {
      let size = x - targetWidth - targetX;
      if (el.style.clientWidth === 0) return;
      size = (el.clientWidth / el.parentElement.clientWidth) * 100 + (size / el.parentElement.clientWidth) * 100;
      if (size < 30) size = 30;
      if (size > 70) size = 70;
      resize.size = size || resize.size;
      el.style.width = `${resize.size}%`;
    });
  }
}

// функция получения параметров
function getParams(
  module: string,
  command: string,
  groupId: string | number | undefined,
  needRefresh: string,
  path: string,
  sectionId: string | number | undefined,
  prm: any,
  reportID: string | number | undefined,
) {
  const params = {
    Path: path,
    GroupID: groupId,
    NeedRefresh: needRefresh,
    SectionID: sectionId,
    prm: prm,
    ReportID: reportID,
  };
  const config = {
    prefix: module,
    method: "GET",
    url: command,
    params,
  };
  return smetaAxios(config);
}

// функция расчета отступов для параметров в зависимости от уровня вложенности
function getPadding(items, item, index) {
  let padding = 15;
  const level = item.Level ? item.Level : 0;

  if (items.length - 1 > index && level < items[index + 1].Level && checkNextItemsVisible(items, item, index)) {
    padding -= 15;
  }
  if (item.Options & ParamSetOption.Markable) {
    padding -= 15;
  }
  if (item.Level) {
    padding += item.Level * 15;
  }
  return padding;
}

// запрос следующего или предыдущего состояния параметров
async function getHistory(data) {
  const params = {
    Path: data.Path,
    History: data.history,
  };
  const config = {
    prefix: Prefixes.progs,
    method: "GET",
    url: "GetParamDialog",
    params,
  };

  return smetaAxios(config);
}

// функция установки стилей для текста названия параметра
function getStyleName(item) {
  return {
    display: "flex",
    flex: "1 1 0",
    color: setColor(item.NameColor),
    ...fontFlagsToCss(item.NameStyle),
  };
}

function getStyleText(item: { TextStyle?: string }) {
  const style: React.CSSProperties = fontFlagsToCss(item.TextStyle);
  if (item.TextStyle !== undefined) {
    style.fontSize = "0.75rem";
  }
  return style;
}

function checkNextItemsVisible(items, item, index) {
  let result = false;
  const level = item.Level ? Number(item.Level) : 0;
  for (let i = index + 1; i < items.length; i++) {
    if (level + 1 !== Number(items[i].Level)) return result;
    if (items[i].Options & 1) {
      result = false;
    } else {
      return true;
    }
  }
  return result;
}
interface ParamsProps {
  /** Модуль используемый для запросов параметров. */
  Module: string;
  /** Команда используемая для запросов параметров. */
  reqCommand: string;
  /** Объект параметров с данными. */
  data: any;
  /** Путь используемый для запросов параметров(если есть). */
  Path?: string;
  /** ID элемента для которого используются параметры, для запроса параметров под конкретный элемент(по необходимости). */
  GroupID?: string | number;
  /** ID секции для которой используются параметры(по необходимости). */
  SectionID?: string | number;
  /** Данные для запроса параметров (по необходимости). */
  prm?: any;
  /** ID отчета для запроса параметров (по необходимости). */
  reportID?: string | number;
  /** Значение `true` отключает кнопки истории. */
  NoHistory?: boolean;
  /** Значение `true` отключает заголовок параметров. */
  NoTitle?: boolean;
  defaultFilter?: boolean;
  NoClearState?: boolean;
  NoSaveSample?: boolean;
  fixHistory?: any;
  setFixHistory?: any;
  currentPage?: any;
  pageTitles?: any;
  onSetParam?: any;
  onEditList?: any;
  onEditParams?: any;
  setChanges?: any;
  notRefresh?: any;
  getRefreshParams?: any;
  id?: string | number;
  onDropDownList?: any;
  noEdit?: boolean;
  requestId?: string;
  from?: string;
  func?: (data: unknown) => void | Promise<void>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function Params(props: ParamsProps) {
  // переменная для хранения данных об истории
  const [history, setHistory] = useState();
  // полные данные параметров
  const [paramsData, setParamData] = useState<any>();
  // данные записей
  const [paramsItems, setParamsItems] = useState<any[]>();
  // записи для отрисовки
  const [paramsJsx, setParamsJsx] = useState();

  const [paramsButtons, setParamsButtons] = useState([]);

  const [paramsButtonsJsx, setParamsButtonsJsx] = useState([]);

  const [title, setTitle] = useState("");

  const [filter, setFilter] = useState(props.defaultFilter);

  const [loading, setLoading] = useState(false);

  const changes = useRef({});

  // размер 1-й колонки для контроля
  const width = useRef(35);

  const [buttonBlockWidth, setButtonBlockWidth] = useState(0);
  // переменная для хранения элемента с редактором
  const editor = useRef<HTMLDivElement>(undefined);

  // карта с функциями редактирования отрисованных редакторов
  const [editionMap, setEditionMap] = useState();

  // хук для получения функций редактирования и записи их в карту выше
  const [getEdition, setGetEdition] = useState();

  // переменная для динамической отрисовки редактора, контролирует отрисовку по нажатой клавише мыши
  const mouseDown = useRef(false);

  // ссылка на контейнер параметров
  const paramsBox = useRef<HTMLDivElement>(null!);

  const needOpenEditor = useRef(undefined);

  const smetaModalId = useContext(SmetaModalsIdContext);

  // Первичная установка объекта параметров
  useEffect(() => {
    // получение данных если они не были переданные из вне
    if (props.data) {
      setParamData(props.data);
    }

    paramsBox.current.update = (data) => {
      // setParamsJsx(null);
      // setEditorMap(new Map());
      // setEditionMap(new Map());

      deleteEditor(editor.current);
      setParamData(data);
    };

    paramsBox.current.focus = () => {
      if (editor.current && !editor.current.classList.contains(clsx(styles.hiddenBlock))) {
        const input = editor.current.querySelector<HTMLInputElement>("input[type=text]");
        if (input) {
          input.focus();
          // проверка на readOnly
          const record = editor.current.closest<HTMLTableRowElement>("TR");
          if (record && record.dataset.editstyle & EditStyle.ReadOnly) return;
          input.select();
        }
      } else {
        const record = paramsBox.current.querySelector<HTMLTableRowElement>("TR");
        if (record) record.click();
      }
    };

    // инициализация карт хранения
    setEditionMap(new Map());
  }, []);

  // при изменении данных снаружи они обновляются
  useEffect(() => {
    if (props.data) {
      // setEditorMap(new Map());
      // setEditionMap(new Map());
      // setParamsJsx(null);
      deleteEditor(editor.current);
      setParamData(props.data);
    } else setParamsJsx(undefined);
  }, [props.data]);

  useEffect(() => {
    if (props.fixHistory && props.setFixHistory) {
      setHistory(props.fixHistory);
      props.setFixHistory(null);
    }
  }, [props.fixHistory]);

  useEffect(() => {
    if (props.currentPage !== undefined && paramsData) {
      setParamsItems(
        paramsData.Items.filter((item) => {
          if (props.currentPage === 0) {
            return item.PageIndex === undefined || Number(item.PageIndex) === 0;
          }

          return Number(item.PageIndex) === props.currentPage;
        }),
      );

      const match = props.pageTitles[props.currentPage].Name.match(/[^\\]+$/);
      if (match) {
        setTitle(match[0]);
      }
    }
  }, [props.currentPage]);

  useEffect(() => {
    // обновление параметров при изменении общих данных
    if (paramsData) {
      // скрытие текущего редактора если он был открыт
      if (editor.current) {
        deleteEditor(editor.current);
      }

      // обновление массива записей
      if (props.currentPage !== undefined && paramsData) {
        setParamsItems([
          ...paramsData.Items.filter((item) => {
            if (props.currentPage === 0) {
              return item.PageIndex === undefined || Number(item.PageIndex) === 0;
            }

            return Number(item.PageIndex) === props.currentPage;
          }),
        ]);
        const match = props.pageTitles[props.currentPage].Name.match(/[^\\]+$/);
        if (match) {
          setTitle(match[0]);
        }
      } else {
        setParamsItems([...paramsData.Items]);

        if (paramsData.Title) {
          // любой символ с конца кроме "\"
          const match = paramsData.Title.match(/[^\\]+$/);
          if (match) {
            setTitle(match[0]);
          }
        }
      }

      if (filter === undefined) {
        setFilter(paramsData.Filter ? true : false);
      }
      // обновление данных истории
      setHistory(paramsData.History);

      if (paramsData?.Buttons?.items?.length) {
        const result = [];
        paramsData.Buttons.items.forEach((item, index) => {
          if (item.Caption && item.Hidden !== "1") result.push({ ...item, id: index });
        });
        setParamsButtons([...result]);
      }

      paramsBox.current.dialogButtonClick = (id, progId, callBack) => {
        dialogButtonClick({ currentTarget: { id } }, paramsData.Path, progId, callBack);
      };
    }
  }, [paramsData]);

  useEffect(() => {
    // обновление отрисованных записей
    if (paramsItems) {
      setParamsJsx(getJsxParams(paramsItems, width));
    }
  }, [paramsItems]);

  useEffect(() => {
    if (paramsData?.SelectedIndex) {
      const tr = paramsBox.current?.querySelector<HTMLTableRowElement>(
        `TR[param-index="${paramsData?.SelectedIndex}"]`,
      );
      tr?.click();
    }
  }, [paramsJsx]);

  useEffect(() => {
    if (paramsButtons.length === 0) return;
    setParamsButtonsJsx(getParamsButtons(paramsButtons));
  }, [paramsButtons]);

  // заполнение карты с функциями редактирования при отрисовке нового редактора
  useEffect(() => {
    if (getEdition) {
      editionMap.set(getEdition.id, {
        setValue: getEdition.setValue,
        setInputValue: getEdition.setInputValue,
        value: getEdition.value,
        inputValue: getEdition.inputValue,
        setSelection: getEdition.setSelection,
      });
    }
  }, [getEdition]);

  // разворачивание записей при первой отрисовке, если они должны быть развернуты
  useLayoutEffect(() => {
    if (paramsJsx) {
      paramsBox.current.querySelectorAll("#expandButtonParams").forEach((el) => {
        if ((Number(el.dataset.collapsed) & ParamSetOption.Collapsed) !== ParamSetOption.Collapsed) {
          el.closest("TR").dataset.collapsed = "1";
          expandRec({ target: el });
        }
      });

      if (needOpenEditor.current) {
        setTimeout(() => {
          if (editor.current) {
            needOpenEditor.current = editor.current.closest("TR");
            renderEditor({ target: needOpenEditor.current });
            needOpenEditor.current = undefined;
            return;
          }
          renderEditor({ target: needOpenEditor.current });
          needOpenEditor.current = undefined;
        }, 1);
      }
    }
  }, [paramsJsx]);

  // функция для получения кнопки разворачивания записей
  function getExpandOrMarkButton(items, item, index) {
    const level = item.Level ? item.Level : 0;
    if (items.length - 1 > index && level < items[index + 1].Level && checkNextItemsVisible(items, item, index)) {
      return (
        <IconButton
          id="expandButtonParams"
          data-collapsed={item.Options}
          name="expandButton"
          onClick={async (ev) => {
            const record = ev.target.closest("tr");
            await collapseReq(
              record.id.split("_")[1],
              props.Path ? props.Path : paramsData.Path,
              record.dataset.collapsed === "1" ? "0" : "1",
            );
            expandRec(ev);
          }}
          className={clsx(
            styles.paramsExpandButton,
            Number(item.Options) & ParamSetOption.Collapsed && styles.paramsExpandButtonRotate,
          )}
        >
          <ExpandMoreIcon style={{ height: "15px", width: "15px" }} />
        </IconButton>
      );
    }

    if (Number(item.Options) & ParamSetOption.Markable) {
      return (
        <IconButton
          id="markButtonParams"
          title="Маркировать"
          data-enabled="false"
          onClick={async (ev) => {
            const bttn = ev.target.closest("#markButtonParams");
            const icon = bttn.querySelector("path");
            if (bttn.dataset.enabled === "true") {
              icon.style.color = "#cccccc";
              bttn.dataset.enabled = "false";
              bttn.title = "Маркировать";
            } else {
              icon.style.color = "#006cbf";
              bttn.dataset.enabled = "true";
              bttn.title = "Снять маркировку";
            }
            const record = ev.target.closest("tr");
            record.dataset.marked = bttn.dataset.enabled === "true" ? "1" : "0";

            await getSetParamRequest("marker")({
              Path: props.Path ? props.Path : paramsData.Path,
              ID: record.id.split("_")[1],
              GroupID: paramsData.GroupID,
              Marked: record.dataset.marked,
            });
          }}
          className={clsx(styles.paramsMarkerButton)}
        >
          <CircleIcon style={{ height: "5px", width: "5px", color: "#cccccc" }} />
        </IconButton>
      );
    }
  }

  // запрос сворачивания и разворачивания записи для сервера
  async function collapseReq(id: string, path: string, collapsed: string) {
    const params = {
      Path: path,
      ID: id,
      Collapsed: collapsed,
    };
    const config = {
      prefix: Prefixes.progs,
      method: "GET",
      url: "ParamCollapsed",
      params,
    };

    return smetaAxios(config);
  }

  // Функция скрытия и отображения записей при клике на кнопку expandButton
  function expandRec(ev: { target: HTMLElement }) {
    // получение кнопки на текущей записи
    const button = ev.target.closest<HTMLButtonElement>("BUTTON")!;
    // получение текущей записи
    const record = ev.target.closest<HTMLTableRowElement>("TR")!;
    const tdName = record.querySelector<HTMLTableCellElement>(".td-name")!;
    // получение уровня вложенности
    const level = record.dataset.level;
    // получение следующей записи
    let nextRec = record.nextElementSibling as HTMLTableRowElement | null;

    // получение id родительской записи
    // const parentID = record.id.split("_")[1];

    //выражение для проверки состояния развернутости записи
    const condition = record.dataset.collapsed === "1";
    // Сокрытие или раскрытие всех дочерних записей у родительской.
    // Цикл работает до тех пор, пока уровень вложенности следующей записи больше чем уровень первоначальной записи
    while (nextRec && nextRec.dataset.level > level) {
      // проверка привязки к родительской записи
      // if (nextRec.dataset.parentid === parentID) {
      // проверка на наличие вложенных записей
      const nextButton = nextRec.querySelector<HTMLButtonElement>("button[name=expandButton]");
      // если вложенные записи были развернуты, то они свернутся при сворачивании записей родителя
      if (nextButton && nextRec.dataset.collapsed === "0") {
        nextRec.dataset.collapsed = "1";
        nextButton.classList.add(clsx(styles.paramsExpandButtonRotate));
      }
      // сокрытие или раскрытие записей в зависимости от условия
      if (condition) {
        nextRec.classList.remove(clsx(styles.hiddenBlock));
        const td = nextRec.querySelector<HTMLTableCellElement>(".td-name");
        if (td && tdName) td.style.width = tdName.style.width;
      } else {
        nextRec.classList.add(clsx(styles.hiddenBlock));
      }
      // проверка привязки к родительской записи
      if (
        nextRec.dataset.level !== `${Number(level) + 1}` ||
        Number(nextRec.dataset.options) & ParamSetOption.Disabled
      ) {
        nextRec.classList.add(clsx(styles.hiddenBlock));
      }
      nextRec = nextRec.nextElementSibling as HTMLTableRowElement | null;
    }

    // поворот кнопки при сворачивании
    if (condition) button.classList.remove(clsx(styles.paramsExpandButtonRotate));
    else button.classList.add(clsx(styles.paramsExpandButtonRotate));
    record.dataset.collapsed = condition ? "0" : "1";
  }

  function onCloseSelection(data) {
    const editVal =
      data.record.dataset.editval !== undefined
        ? data.record.dataset.editval
        : data.record.dataset.value !== undefined
          ? data.record.dataset.value
          : "";
    const value =
      data.record.dataset.value !== undefined
        ? data.record.dataset.value
        : data.record.dataset.editval !== undefined
          ? data.record.dataset.editval
          : "";

    data.setValue({
      label: editVal,
      id: data.record.dataset.objref !== undefined ? data.record.dataset.objref : "",
    });
    data.setInputValue(editVal);
    data.record.querySelector('[textvalue="true"]').innerText = value;
  }

  // функция для выбора запроса
  // возвращает функцию в которую нужно передать data
  // пример: getSetParamRequest(selector)({data})
  function getSetParamRequest(selector: string) {
    const requests: Record<string, (data: any) => any> = {
      marker: (data) => {
        const params = {
          Path: data.Path,
          ID: data.ID,
          GroupID: data.GroupID || "0",
          Marked: data.Marked,
        };
        const config = {
          prefix: Prefixes.progs,
          method: "GET",
          url: "SetParamProperty",
          params,
        };
        return smetaAxios(config);
      },
      custom: (data) => {
        return props.onSetParam(data);
      },
      customList: (data) => {
        return props.onEditList(data);
      },
      default: (data) => {
        const params = {
          Path: data.Path,
          ID: data.ID,
          GroupID: data.GroupID || "0",
          ObjRef: data.ObjRef || "0",
          CheckState: data.CheckState,
          Value: data.Value,
          Condition: data.Condition,
          Selection: (data.MultiSelect || data.Selection) && data.Selection,
          ListIndex: data.ListIndex || undefined,
          TextChanged: data.TextChanged,
          WSM: "1",
        };
        const config = {
          prefix: Prefixes.progs,
          method: "GET",
          url: "SetParamProperty",
          params,
          loadMask: false,
        };
        return smetaAxios(config);
      },
    };
    return selector && requests[selector] ? requests[selector] : requests.default;
  }

  const getSelector = (data) => {
    if (data.listClick && props.onEditList) {
      return "customList";
    }
    if (props.onSetParam) {
      return "custom";
    }
    return "default";
  };

  // функция на редактирование параметров
  async function onEdit(data) {
    needOpenEditor.current = data.record;

    const textValueDiv = data.record.querySelector('[textvalue="true"]');
    // если нет изменений значения или id, или состояния чекбокса, то устанавливается старое
    if (data.value === undefined) data.value = data.record.dataset.value;
    if (data.tag === undefined) data.tag = data.record.dataset.objref;
    if (data.CheckState === undefined) {
      data.CheckState = data.record.dataset.checkstate;
    }
    if (data.Condition === undefined) {
      data.Condition = data.record.dataset.condition;
    }

    mouseDown.current = false;
    if (data.value !== undefined) textValueDiv.innerText = data.value;
    setLoading(true);
    // получение запроса для редактирования и ответа
    const selector = getSelector(data),
      setParamRequest = getSetParamRequest(selector),
      requestData = {
        Path: props.Path ? props.Path : paramsData.Path,
        ID: data.record.id.split("_")[1],
        GroupID: paramsData.GroupID,
        ObjRef: data.tag,
        Value: data.value,
        Condition: data.Condition,
        CheckState: data.CheckState,
        MultiSelect: data.multiselect,
        Selection: data.selection,
        ListIndex: data.listindex,
        TextChanged: data.textchanged !== undefined ? data.textchanged : "1",
        Module: data.record.dataset.module,
        ObjType: data.record.dataset.datatype,
      };
    const res = await setParamRequest(requestData);

    setLoading(false);

    props.onEditParams?.(res, data);
    // Установка значений параметров
    settingValues(res, data);

    changes.current[data.record.dataset.fieldname || data.record.dataset.shortname] = {
      ...data.record.dataset,
      tag: data.tag,
      value: data.value,
    };
    props?.setChanges?.({ ...changes.current });
  }

  // функция установки локальных значений параметров
  function settingValues(res, data) {
    // при наличии Токена установка идет через токен процесс
    if (res) {
      if (res.Token) {
        tokenProcessingTest(res, {
          func: (val) => {
            settingValues(val, data);
          },
        });
        return;
      }

      // открытие окна с выбором элементов при неточном вводе в ручную
      if (res.Selection && res.Selection.length && !data.noSelection) {
        if (res.Selection.length === 1) {
          onEdit({
            ...data,
            value: res.Selection[0].text,
            tag: res.Selection[0].id,
            noSelection: true,
          });
          return;
        }

        const selectionRequestId = res.Params?.RequestID ?? res.RequestID ?? props.requestId;

        smetaModals.open(
          <DialogSetObjText
            list={res.Selection}
            onEdit={onEdit}
            record={data.record}
            CheckState={data.CheckState}
            RequestID={selectionRequestId}
            from={props.from}
            func={props.func}
            resumeAfterEdit={selectionRequestId !== undefined}
            createNew={res.CreateNew}
            module={data.type}
            objType={data.datatype}
          />,
          {
            Title: "Выберите элемент из списка",
            style: getStyleWindow(),
            blockMaximize: true,
            onClose: async () => {
              onCloseSelection(data);
              if (selectionRequestId !== undefined) {
                await formEdit("0", props.func, {}, selectionRequestId, props.from);
              }
            },
          },
        );
        return;
      }

      // открытие окна с созданием нового объекта
      if (res.CreateNew) {
        smetaModals.open(
          <DialogCreateObj
            onEdit={onEdit}
            inputNameObj={res.CreateNew.Text}
            spanText={res.CreateNew.Label}
            CLSID={res.CreateNew.CLSID}
            ObjType={data.datatype}
            Module={data.type}
            groups={res.CreateNew.Groups}
            record={data.record}
            CheckState={data.CheckState}
          />,
          {
            Title: "Создать новый объект",
            style: getStyleWindow(`${res.CreateNew.CLSID}${res.CreateNew.Groups ? "Group" : ""}`),
            hiddenButton: true,
            blockMaximize: true,
            blockSaveLocation: true,
          },
        );
        return;
      }

      if (!res.Values) return;

      // обновление значений из ответа
      res.Values.forEach((item) => {
        // редактируемая запись
        const rec = data.record;
        // контейнер со значением параметра
        const textValueDiv = rec.querySelector('[textvalue="true"]');

        let inpValue = item.EditVal ? item.EditVal : item.Value !== undefined ? item.Value : "";

        const txtFldValue = item.Value !== undefined ? item.Value : item.EditVal !== undefined ? item.EditVal : "";

        const index = rec.id.split("_")[2];
        const paramItem = paramsData.Items[index];
        paramItem.EditVal = inpValue;
        paramItem.Value = item.Value ? item.Value : "";
        paramItem.ObjRef = item.ObjRef ? item.ObjRef : "0";
        if (item.CheckState) {
          paramItem.CheckState = item.CheckState;
        }
        paramItem.Selection = item.Selection;

        // заполнение записи данными
        rec.dataset.editval = inpValue;
        rec.dataset.value = item.Value ? item.Value : "";
        rec.dataset.objref = item.ObjRef ? item.ObjRef : "0";

        if (item.CheckState !== undefined) {
          if (data.setStateCheckBox) data.setStateCheckBox(item.CheckState);
          rec.dataset.checkstate = item.CheckState;
        }

        textValueDiv.innerText = txtFldValue;

        textValueDiv.style.color =
          textValueDiv.innerText < 0 && rec.dataset.options & ParamSetOption.RedNegative
            ? "red"
            : setColor(item.TextColor);

        rec.dataset.selection = item.Selection;

        // обновление значения в редакторе
        if (editor.current) {
          const edition = editionMap.get(rec.id);
          if (edition) {
            if (data.fixVal) {
              inpValue = data.fixVal(inpValue);
            }
            edition.setValue({
              label: inpValue,
              id: item.ObjRef ? item.ObjRef : "0",
            });
            edition.setInputValue(inpValue);
            if (item.Selection !== undefined) {
              edition.setSelection(item.Selection);
            } else {
              edition.setSelection("");
            }
          }
        }
      });

      setParamData({ ...paramsData });
      // при необходимости обновить все записи перерисуются (запрос с данными по необходимости)
      needRefreshParams(res);
    }
  }

  async function needRefreshParams(res) {
    if (res.NeedRefresh === "1" && !props.notRefresh) {
      if (props.getRefreshParams) {
        const json = await props.getRefreshParams(props, paramsData);
        deleteEditor(editor.current);
        setParamData(json);
        return;
      }
      if (props.Module === "documents") {
        const params = {
          DocCfgID: props.id,
          SectionID: props.SectionID,
          GridState: "1",
        };
        const config = {
          prefix: Prefixes.doc,
          method: "GET",
          url: "GetDocumentLayout",
          params,
        };
        smetaAxios(config).then((res) => {
          deleteEditor(editor.current);
          setParamData(res.Params);
        });
        return;
      }
      setLoading(true);
      getParams(
        props.Module,
        props.reqCommand,
        props.GroupID,
        "1",
        paramsData.Path,
        props.SectionID,
        props.prm,
        props.reportID,
      ).then((res) => {
        deleteEditor(editor.current);
        setParamData(res);
        setLoading(false);
      });
    }
  }

  // функция открытия модального окна в редакторе
  async function onEditButtonClick(data) {
    if (data.subData.props.editParam !== undefined) {
      const params = {
        ID: data.subData.props.record.id.split("_")[1],
        Path: props.Path || paramsData.Path,
        WSM: "1",
      };
      const config = {
        prefix: Prefixes.progs,
        method: "GET",
        url: "EditParamProperty",
        params,
      };
      const json = await smetaAxios(config);
      if (json?.Token)
        tokenProcessingTest(json, {
          ...data.subData,
          func: (res) => {
            needRefreshParams(res);
          },
        });
      return;
    }

    if (data.json) {
      tokenProcessingTest(data.json, data.subData);
      return;
    }

    if (data.datatype <= 12 && data.datatype > 0) {
      smetaModals.open(
        <TextAreaWithButtons
          props={{
            ...data.subData.props,
            setValue: data.setValue,
            setInputValue: data.setInputValue,
            Title: data.subData.props.record.dataset.name,
          }}
        />,
        {
          Title: data?.subData?.props?.record?.dataset?.name || "Текст параметра",
          style: getStyleWindow(),
          hiddenButton: true,
        },
      );
      return;
    }
  }

  // функция значений для выпадающего списка в редакторе
  async function onDropDownList(data: any, checklist?: boolean) {
    let json;
    if (props.onDropDownList) {
      json = await props.onDropDownList({ module: data.record.dataset.module, datatype: data.record.dataset.datatype });
    } else {
      const params = {
        Path: props.Path || paramsData.Path,
        ID: data.record.id.split("_")[1],
      };
      const config = {
        prefix: Prefixes.progs,
        method: "GET",
        url: "GetParamValues",
        params,
      };
      json = await smetaAxios(config);
    }

    if (json && json.Items) {
      return getEditorListFormat(json.Items, { checklist });
    }
  }

  // функция для рендера или сокрытия/раскрытия редактора
  function renderEditor(ev: { target: EventTarget | null }) {
    if (!ev.target || props.noEdit) return;
    // выбранная запись
    const record = (ev.target as HTMLElement).closest<HTMLTableRowElement>("TR");

    if (!record) return;
    // проверка на отображение редактора
    if (!record.querySelector('div[editor="true"]')?.classList.contains(clsx(styles.hiddenBlock))) return;

    record.style.backgroundColor = "whitesmoke";

    // контейнер для редактора
    const editorDiv = record.querySelector<HTMLDivElement>('[editor="true"]')!;
    // контейнер для текста параметров
    const textValueDiv = record.querySelector<HTMLDivElement>('[textvalue="true"]')!;
    // удаление(скрытие) другого отрисованного редактора
    if (editor.current && editor.current !== editorDiv) {
      deleteEditor(editor.current);
    }
    const editRoot: Root = editorDiv.root || createRoot(editorDiv);
    editorDiv.root = editRoot;
    editorDiv.classList.remove(clsx(styles.hiddenBlock));
    textValueDiv.classList.add(clsx(styles.hiddenBlock));
    // отрисовка редактора
    editRoot.render(
      <Editor
        placeholder=" "
        styleInput={getStyleText({ TextStyle: record.dataset.textstyle })}
        disabled={record.dataset.locked === "1"}
        groupid={record.dataset.groupid}
        current={record.dataset.current}
        fieldname={record.dataset.fieldname}
        name={record.dataset.name}
        type={record.dataset.module}
        record={record}
        objref={record.dataset.objref}
        value={record.dataset.editval}
        datatype={record.dataset.datatype}
        editStyle={record.dataset.editstyle}
        checkstate={record.dataset.checkstate}
        onEdit={onEdit}
        onEditButtonClick={onEditButtonClick}
        onDropDownList={onDropDownList}
        getEdition={setGetEdition}
        editParam={record.dataset.onedit}
        multisel={record.dataset.options & ParamSetOption.Detalization}
        selection={record.dataset.selection}
        editMask={record.dataset.editmask}
        // disabled={false}
        func={settingValues}
      />,
    );
    // }

    // отрисованный редактор
    editor.current = editorDiv;

    setTimeout(() => {
      // фокус на поле ввода
      const input = editorDiv.querySelector<HTMLInputElement>("input[type=text]");
      if (input) {
        input.focus();
        // проверка на readOnly
        if (record.dataset.editstyle & EditStyle.ReadOnly) return;
        input.select();
      } else {
        const textArea = editorDiv.querySelector("textarea");
        if (!textArea) return;
        textArea.focus();
        // проверка на readOnly
        if (record.dataset.editstyle & EditStyle.ReadOnly) return;
        textArea.select();
      }
    });
  }

  // функция скрытия редактора и отображения текста параметров
  function deleteEditor(editor?: HTMLDivElement) {
    if (!editor?.classList) return;
    if (!editor.classList.contains(clsx(styles.hiddenBlock))) {
      const record = editor.closest<HTMLTableRowElement>("TR")!;
      record.style.backgroundColor = "";
      const textValueDiv = record.querySelector<HTMLDivElement>('[textvalue="true"]')!;
      editor.classList.add(clsx(styles.hiddenBlock));
      textValueDiv.classList.remove(clsx(styles.hiddenBlock));
    }
  }

  // функция на нажатие стрелок
  // проверяет следующий элемент на отображение и рисует в нем редактор
  function onKeyArrow(ev: React.KeyboardEvent<HTMLTableRowElement>) {
    let record;
    switch (ev.key) {
      case "ArrowDown":
        record = ev.target.closest("TR").nextElementSibling;
        if (record) {
          if (record.classList.contains(clsx(styles.hiddenBlock))) {
            while (record !== null) {
              record = record.nextElementSibling;
              if (record && !record.classList.contains(clsx(styles.hiddenBlock))) {
                renderEditor({ target: record });
                break;
              }
            }
          } else {
            renderEditor({ target: record });
          }
        }

        break;
      case "ArrowUp":
        record = ev.target.closest("TR").previousElementSibling;
        if (record) {
          if (record.classList.contains(clsx(styles.hiddenBlock))) {
            while (record !== null) {
              record = record.previousElementSibling;
              if (record && !record.classList.contains(clsx(styles.hiddenBlock))) {
                renderEditor({ target: record });
                break;
              }
            }
          } else {
            renderEditor({ target: record });
          }
        }
        break;
      default:
        break;
    }
  }

  // функция установки размеров блока с кнопками
  function getButtonColWidth(options: string, other: { Conditions?: string }) {
    let res = 0;
    if (options & ParamSetOption.History) {
      res += 20;
    }
    if (other) {
      res += other.Conditions ? 20 : 0;
    }
    return res;
  }

  const historyButtonClick = (item, index) => {
    const paramsRequest = new Map();
    paramsRequest
      .set("prefix", "programs")
      .set("Path", props.Path ? props.Path : paramsData.Path)
      .set("ID", item.ID);
    smetaModals.open(
      <DialogHistory
        noEdit={props.noEdit}
        paramsRequest={paramsRequest}
        Module={item.Module}
        EditStyle={item.EditStyle}
        DataType={item.DataType}
        Options={item.Options}
        Values={item.Values}
        onSelect={(json) => {
          settingValues(
            { Values: [json.CheckState === undefined ? { ...json, CheckState: "0" } : json] },
            {
              record: paramsBox.current.querySelector(`#param_${item.ID}_${index}`),
            },
          );
        }}
      />,
      {
        Title: item.Name,
        style: getStyleWindow(),
        blockMaximize: true,
        blockSaveLocation: true,
      },
    );
  };

  // Функция отрисовки записей для таблицы параметров
  function getJsxParams(items, width: React.RefObject<number>) {
    let colWidth;
    const returnArr = items.map((item, index) => {
      const expandButton = getExpandOrMarkButton(items, item, index);
      // условие для отрисовки чекбокса отдельно
      const editStyle = item.EditStyle & 4 ? item.EditStyle - 4 : item.EditStyle;

      colWidth = getButtonColWidth(item.Options, {
        Conditions: item.Conditions,
      });
      if (buttonBlockWidth < colWidth) {
        setButtonBlockWidth(colWidth);
      }
      return (
        <tr
          // данные параметра хранятся внутри записи
          id={`param_${item.ID}_${index}`}
          key={`param-key_${item.ID}_${index}`}
          param-index={item.ID}
          data-datatype={item.DataType}
          data-editstyle={editStyle}
          data-fieldname={item.FieldName}
          data-name={item.Name}
          data-mapid={item.MapID}
          data-module={item.Module}
          data-options={item.Options}
          data-orderno={item.OrderNo}
          data-shortname={item.ShortName}
          data-level={item.Level ? item.Level : 0}
          data-parentid={item.ParentID}
          data-collapsed={(Number(item.Options) & ParamSetOption.Collapsed) === 32 ? "1" : "0"}
          data-value={item.Value}
          data-editval={item.EditVal !== undefined ? item.EditVal : item.Value}
          data-objref={item.ObjRef}
          data-groupid={paramsData.GroupID}
          data-current={item.Current}
          data-checkstate={item.CheckState}
          data-marked={"0"}
          data-locked={item.Locked}
          data-onedit={item.OnEdit}
          data-condition={item.Condition !== undefined ? item.Condition : item.Conditions ? "1" : undefined}
          data-textstyle={item.TextStyle}
          data-selection={item.Selection}
          data-editmask={item.EditMask}
          onClick={(ev) => {
            renderEditor(ev);
          }}
          onKeyDown={onKeyArrow}
          onMouseEnter={(ev) => {
            if (mouseDown) {
              if (mouseDown.current) renderEditor(ev);
            }
          }}
          className={clsx(
            styles.paramsRecord,
            ((item.Level && item.Level !== "0") ||
              Number(item.Options) & ParamSetOption.Disabled ||
              Number(item.Options) & ParamSetOption.Hidden) &&
              styles.hiddenBlock,
          )}
        >
          {/* Имя параметра */}
          <td
            id={`name_${item.ID}`}
            title={item.Name}
            className={clsx(styles.paramsName, "td-name")}
            style={{
              paddingLeft: getPadding(items, item, index),
              width: `${width.current}%`,
            }}
          >
            {expandButton}
            <span style={getStyleName(item)}>{item.Name}</span>
            {/* Колонка для кнопок история, выражение и тд */}
            <div
              className={clsx(styles.paramsConditions)}
              style={{
                width: getButtonColWidth(item.Options, {
                  Conditions: item.Conditions,
                }),
              }}
            >
              <IconButton
                onClick={() => historyButtonClick(item, index)}
                className={clsx(
                  styles.paramsHistoryButton,
                  (item.Options & ParamSetOption.History) === 0 && styles.hiddenBlock,
                )}
              >
                <HistoryIcon style={{ height: "15px", width: "15px" }} />
              </IconButton>
              <ConditionButton
                visible={item.Conditions ? true : false}
                conditions={item.Conditions}
                condition={item.Condition ? item.Condition : "1"}
                onEdit={onEdit}
                recID={`param_${item.ID}_${index}`}
                paramsBoxRef={paramsBox}
              />
            </div>
          </td>
          {/* Разделитель */}
          <td onMouseDown={onMouseDown} className={clsx(styles.paramsSplitter)} id="splitter-ID">
            <br></br>
          </td>
          {/* Значение параметра */}
          <td id={`value_${item.ID}`} className={styles.paramsValueConteiner}>
            <div className={clsx(styles.paramsCheckContainer, (item.EditStyle & 4) === 0 && styles.hiddenBlock)}>
              {/* чекбокс с множеством состояний */}
              <CheckBoxMultiCheck
                onEdit={onEdit}
                MultiCheckSet={item.MultiCheckSet}
                CheckState={item.CheckState}
                disabled={props.noEdit}
              />
            </div>
            {/* текстовое значение параметра */}
            <div
              className={clsx(styles.paramsValue)}
              style={{
                color: item.Value < 0 && item.Options & ParamSetOption.RedNegative ? "red" : setColor(item.TextColor),
                ...getStyleText(item),
              }}
              textvalue={"true"}
            >
              {item.Value}
            </div>

            {/* контейнер для редактора */}
            <div className={clsx(styles.paramsEditorContainer, styles.hiddenBlock)} editor={"true"}></div>
          </td>
        </tr>
      );
    });

    return returnArr;
  }

  // функция для вызова истории
  async function historyClick(num: number) {
    const json = await getHistory({
      Path: props.Path ? props.Path : paramsData.Path,
      history: num,
    });
    // обновление параметров
    if (json) {
      // setEditorMap(new Map());
      // setEditionMap(new Map());
      setParamsJsx(null);
      deleteEditor(editor.current);
      setParamData({ ...json });
    }
  }

  async function contextMenuHandler(data) {
    const command = data.value;
    let json;
    switch (command) {
      case "SelectSample":
        deleteEditor(editor.current);
        json = await HandleSamples({
          Path: props.Path ? props.Path : paramsData.Path,
          Command: "load",
          Name: data.name,
        });
        deleteEditor(editor.current);
        setParamsJsx(null);
        setParamData(json);

        break;
      case "DeleteSample":
        json = await HandleSamples({
          Path: props.Path ? props.Path : paramsData.Path,
          Command: "drop",
          Name: data.name,
        });
        if (json.Result === "1") {
          paramsData.Sample = undefined;
          deleteEditor(editor.current);
          setParamsJsx(null);
          setParamData({ ...paramsData });
        }
        break;
      case "SaveSample":
        smetaModals.open(
          <DialogSaveSample
            props={{
              Path: props.Path ? props.Path : paramsData.Path,
              value: paramsData.Sample,
            }}
          />,
          {
            Title: "Сохранение шаблона параметров",
            style: getStyleWindow("Sample"),
          },
        );
        break;
      case "ClearValues":
        json = await HandleSamples({
          Path: props.Path ? props.Path : paramsData.Path,
          Command: "reset",
          SectionID: props.SectionID,
        });
        deleteEditor(editor.current);
        setParamsJsx(null);
        setParamData({ ...json });
        break;
      case "FilterParams":
        setFilter(!filter);
        break;
      default:
        break;
    }
  }

  async function onMenuClick() {
    const params = {};
    const config = {
      prefix: Prefixes.progs,
      method: "POST",
      url: "HandleSamples",
      params,
      data: {
        Path: props.Path || paramsData.Path,
        Command: "list",
      },
    };
    const json = await smetaAxios(config);

    return { json: json, Sample: paramsData.Sample, filter: filter };
  }

  async function filterOnEdit(data: any) {
    const json = await HandleSamples({
      Path: props.Path ? props.Path : paramsData.Path,
      Command: "filter",
      Name: data.value,
    });
    setParamsJsx(null);
    setParamData({ ...json });
  }

  const dialogButtonClick = async (ev, path, progId, callBack) => {
    const id = ev.currentTarget.id;
    const params = {
      Path: path,
      ProgID: progId || "0",
      ID: Number(id) + 1,
      WSM: "1",
    };
    const config = {
      prefix: Prefixes.progs,
      method: "POST",
      url: "DialogButtonClick",
      params,
    };
    const json = await smetaAxios(config);
    if (json?.Token) {
      tokenProcessingTest(json, {
        func: (res) => {
          needRefreshParams(res);
        },
      });
    } else {
      if (id === "-1") {
        smetaModals.close(smetaModalId);
        await callBack();
        return;
      }

      needRefreshParams(json);
    }
  };

  const getParamsButtons = (buttons) => {
    return buttons.map((item, index) => {
      return (
        <Button
          onClick={(ev) => dialogButtonClick(ev, paramsData.Path)}
          id={item.id}
          key={`paramsButton-${index}`}
          variant="outlined"
          className={clsx(styles.paramsSubButton)}
          style={{
            width: "120px",
          }}
        >
          {item?.Caption}
        </Button>
      );
    });
  };

  return (
    <ContextMenu
      for={"params"}
      Menu={getDefaultMenu("HandleParams", {
        NoClearState: props.NoClearState ? true : false,
        NoSaveSample: props.NoSaveSample ? true : false,
      })}
      onRightClick={onMenuClick}
      onMenuItemClick={contextMenuHandler}
    >
      <ClickAwayListener
        onClickAway={(ev) => {
          mouseDown.current = false;
          resize = {};
          if (!editor.current || editor.current.classList.contains(clsx(styles.hiddenBlock))) {
            return;
          }
          const target = ev.target as HTMLElement;
          if (
            target.closest("[checklist]") ||
            target.closest("[calendar]") ||
            (target.closest(".background_ModalDialog") &&
              target.closest(".background_ModalDialog") !== paramsBox.current.closest(".background_ModalDialog")) ||
            target.closest("LI") ||
            target.classList.contains("MuiBackdrop-root") ||
            target.closest("#applyButton")
          ) {
            return;
          }
          if (editor.current) {
            editor.current.closest<HTMLTableRowElement>("TR")!.style.backgroundColor = "";
            deleteEditor(editor.current);
          }
        }}
      >
        <div
          id={"paramsBox"}
          ref={paramsBox}
          onMouseDown={() => {
            mouseDown.current = true;
          }}
          onMouseUp={() => {
            mouseDown.current = false;
          }}
          className={clsx(styles.paramsBox)}
        >
          {loading && (
            <div className={styles.paramsLoadingMask}>
              <LoadingMask />
            </div>
          )}
          <div className={clsx(styles.paramsTitleScroll, props.NoTitle && styles.hiddenBlock)}>
            <div className={clsx(styles.paramsTitleContainer, props.NoTitle && styles.hiddenBlock)}>
              <div className={clsx(styles.paramsTitle)} title={title}>
                {title}
              </div>
            </div>
          </div>
          <div className={clsx(styles.paramsFilter, !filter && styles.hiddenBlock)}>
            <div className={clsx(styles.paramsFilterLabel)}>Фильтр:</div>
            <div className={clsx(styles.paramsFilterInput)}>
              <Editor
                value={paramsData && paramsData.Filter ? paramsData.Filter : ""}
                onEdit={filterOnEdit}
                placeholder=""
              />
            </div>
          </div>
          <div className={styles.paramsTableContainer}>
            {paramsJsx ? (
              <div
                onMouseMove={onMouseMove}
                onMouseUp={(ev) => onMouseUp(ev, width)}
                className={clsx(styles.paramsTable)}
              >
                <tbody>{paramsJsx}</tbody>
              </div>
            ) : (
              <LoadingMask />
            )}
            {paramsJsx && (
              <div className={clsx(styles.paramsButtonsContainer)}>
                {paramsButtonsJsx?.length > 0 && paramsButtonsJsx}
              </div>
            )}
          </div>
          <div className={clsx(styles.paramsListHistoryButtons, !history && styles.hiddenBlock)}>
            <IconButton
              disabled={history === "2"}
              onClick={() => {
                historyClick(-1);
              }}
              className={clsx(styles.paramsListHistoryButton)}
            >
              <KeyboardDoubleArrowLeftIcon />
            </IconButton>
            <div className={clsx(styles.flexContaner)}></div>
            <IconButton
              disabled={history === "1"}
              onClick={() => {
                historyClick(1);
              }}
              className={clsx(styles.paramsListHistoryButton)}
            >
              <KeyboardDoubleArrowRightIcon />
            </IconButton>
          </div>
        </div>
      </ClickAwayListener>
    </ContextMenu>
  );
}
